import { createLazyFileRoute } from "@tanstack/react-router";

import { EditPanelPage } from "@/features/admin/routes/PanelEdit";

export const Route = createLazyFileRoute("/_auth/admin/panels/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditPanelPage id={params.id} />;
  },
});
